<template>
    <div class="col-xxl-12 col-xl-12 box-col-12 col-12">
      <div class="card p-3">
        <div class="card-header p-0 p-3">
          <div class="summary">Summary</div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="title-bold">Total commission</span>
                <span class="text-bold">{{ formatCurrency(totalCommission) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="label-text">Total face value</span>
                <span class="value-text">{{ formatCurrency(totalFaceValue) }}</span>
              </div>
              <hr />
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="label-text">Transactions</span>
                <span class="value-text">{{ transactions }}</span>
              </div>
              <hr />
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="label-text">Fees</span>
                <span class="value-text">{{ formatCurrency(fees) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="label-text">Refunds</span>
                <span class="value-text">{{ formatCurrency(refunds) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="title-bold">Total fees & refunds</span>
                <span class="value-text font-weight-bold">{{ formatCurrency(fees+refunds) }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="title-bold">Amount settled</span>
                <span class="font-weight-bold value-text text-green">{{ formatCurrency(amountSettled) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center ">
                <span class="label-text">Amount balance</span>
                <span class="value-text">{{ formatCurrency(amountBalance) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="sublabel-text">(Money in your account pending withdrawal)</span>
                <span class="value-text"></span>
              </div>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
    import { ref, computed } from 'vue';
    import { useReportStore } from '@/store/driver/report';

    const { reportInfo } = useReportStore();

    const totalFaceValue = computed(() => reportInfo.summary.total_face_value || 0);
    const totalCommission = computed(() => reportInfo.summary.total_commission || 0);
    const transactions = computed(() => reportInfo.summary.transactions || 0);
    const fees = computed(() => reportInfo.summary.fees || 0);
    const refunds = computed(() => reportInfo.summary.refunds || 0);
    const amountSettled = computed(() => reportInfo.summary.amount_settled || 0);
    const amountBalance = computed(() => reportInfo.summary.amount_balance || 0);

    const formatCurrency = (value) => {
      const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
      return value < 0 ? `-$${absValue}` : `$${absValue}`;
    };
  </script>
  
  <style scoped>
  .card {
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
  }

  .summary{
    font-family: Euclid Square;
    font-size: 24px;
    font-weight: 500;
    line-height: 30.43px;
    text-align: left;
  }

  .title-bold{
    font-family: Euclid Square;
    font-size: 20px;
    font-weight: 500;
    line-height: 25.36px;
    text-align: left;
  }

  .text-bold{
    font-family: Euclid Square;
    font-size: 20px;
    font-weight: 700;
    line-height: 25.36px;
    text-align: right;
  }
  
  h5 {
    font-size: 24px;
    color: #333;
    font-weight: bold;
  }
  
  hr {
    margin: 20px 0;
    border-top: 2px solid gray;
  }
  
  .d-flex {
    display: flex;
  }
  
  .justify-content-between {
    justify-content: space-between;
  }
  
  .align-items-center {
    align-items: center;
  }
  
  .mb-3 {
    margin-bottom: 1rem;
  }
  
  .mb-4 {
    margin-bottom: 1.5rem;
  }
  
  .font-weight-bold {
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
  .text-danger {
    color: #dc3545;
  }
  
  .label-text {
    font-family: Mulish;
    font-size: 18px;
    font-weight: 400;
    line-height: 22.59px;
    text-align: left;
  }

  .sublabel-text {
    font-size: 16px;
    color: #6c757d;
  }
  
  .value-text {
    font-family: Euclid Square;
    font-size: 20px;
    font-weight: 500;
    line-height: 25.36px;
    text-align: right;
  }
  .text-green {
    color: #00c962;
  }
  </style>
  